module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px",
      "margin-bottom": "20px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Cancel")])], 1)]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": _vm.$v.$error
    }
  }, [_vm._v("\n      Please check that all fields are correct. Incorrect values are highlighted.\n    ")]), _vm._v(" "), _c('event-form', {
    attrs: {
      "regions": _vm.regions,
      "types": _vm.types,
      "$v": _vm.$v
    },
    model: {
      value: (_vm.event),
      callback: function($$v) {
        _vm.event = $$v
      },
      expression: "event"
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('h1', [_vm._v("Special price event")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-9d4fe750"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AddEvent/AddEvent.vue
// module id = 1702
// module chunks = 1